import React, { FC } from 'react';
import { getNextPeriodEnd } from '../common/components';
import {
  compareIsoDates,
  formatDate,
  getDayjs,
  ISODate,
} from '../common/utils';
import { useSystemClassifierItemById } from '../configuration';
import { Frequency } from '../dataobject';

interface GroupedValueDatesProps {
  frequencyId?: number;
  frequency?: string;
  valueDates?: ISODate[];
  separator: React.ReactNode;
}

export const GroupedValueDates: FC<GroupedValueDatesProps> = (props) => {
  const { frequencyId, frequency, valueDates = [], separator } = props;
  const frequencyItem = useSystemClassifierItemById('FREQUENCY', frequencyId);
  const frequencyCode = (frequency ??
    frequencyItem?.code ??
    'WEEK') as Frequency;
  const valueDatePeriods: { start: ISODate; end: ISODate }[] = [];
  {
    valueDates
      .sort((a, b) => compareIsoDates(a, b))
      .forEach((valueDate, index) => {
        let date = getDayjs(valueDate);
        if (!date) return;
        if (index == 0) {
          valueDatePeriods.push({ end: valueDate, start: valueDate });
        } else {
          const period = valueDatePeriods[valueDatePeriods.length - 1];
          let nextDate = getNextPeriodEnd(date, frequencyCode);
          if (nextDate.isSame(period.start)) {
            period.start = valueDate;
          } else {
            valueDatePeriods.push({ end: valueDate, start: valueDate });
          }
        }
      });
  }
  return (
    <>
      {valueDatePeriods.map((period, index) => {
        let label = formatDate(period.start) ?? '';
        if (period.end && period.start !== period.end) {
          label += ' - ' + (formatDate(period.end) ?? '');
        }
        return (
          <span key={index}>
            {index > 0 ? separator : ''}
            {label}
          </span>
        );
      })}
    </>
  );
};
